import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _isEmpty from 'lodash.isempty';
import * as React from 'react';
import styled from 'styled-components';
import { spacing1x } from '../../styles/spacing.js';
import { AvatarUser } from '../AvatarUser/AvatarUser.js';
import { IconHost } from '../IconHost/IconHost.js';
import { Timestamp } from '../Timestamp/Timestamp.js';
import { ActionBtnGroup } from './ActionBtnGroup.js';
import { EntityThumbnail } from './EntityThumbnail.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "imgProps", "predicate", "primaryActions", "secondaryActions", "subject", "thumbnailProps", "timestampProps"];
var EntityContainer = styled.article.withConfig({
  displayName: "Entity__EntityContainer",
  componentId: "sc-qlow86-0"
})(["&&{display:flex;gap:", ";}"], spacing1x);
var StyledTimestamp = styled(Timestamp).withConfig({
  displayName: "Entity__StyledTimestamp",
  componentId: "sc-qlow86-1"
})(["&&{font-size:12px;font-weight:400;}"]);
var ImgContainer = styled.div.withConfig({
  displayName: "Entity__ImgContainer",
  componentId: "sc-qlow86-2"
})(["&&{margin-inline-end:", ";}"], spacing1x);
var Subject = styled.span.withConfig({
  displayName: "Entity__Subject",
  componentId: "sc-qlow86-3"
})(["&&{font-weight:600;}"]);
var EntityTitleContainer = styled.div.withConfig({
  displayName: "Entity__EntityTitleContainer",
  componentId: "sc-qlow86-4"
})(["&&{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}"]);
var EntityDetails = styled.div.withConfig({
  displayName: "Entity__EntityDetails",
  componentId: "sc-qlow86-5"
})(["&&{display:flex;flex-grow:1;justify-content:space-between;min-width:0;}"]);
var EntityBody = styled.div.withConfig({
  displayName: "Entity__EntityBody",
  componentId: "sc-qlow86-6"
})(["&&{display:flex;flex-direction:column;justify-content:center;overflow:hidden;}"]);
var Entity = /*#__PURE__*/React.forwardRef(function Entity2(props, ref) {
  var children = props.children,
    imgProps = props.imgProps,
    predicate = props.predicate,
    primaryActions = props.primaryActions,
    secondaryActions = props.secondaryActions,
    subject = props.subject,
    thumbnailProps = props.thumbnailProps,
    timestampProps = props.timestampProps,
    rest = _objectWithoutProperties(props, _excluded);
  var entityImg;
  if (imgProps.params) {
    var iconHostProps = imgProps;
    entityImg = /*#__PURE__*/jsx(IconHost, _objectSpread(_objectSpread({}, iconHostProps), {}, {
      params: iconHostProps.params
    }));
  } else {
    var avatarProps = imgProps;
    entityImg = /*#__PURE__*/jsx(AvatarUser, _objectSpread(_objectSpread({}, avatarProps), {}, {
      hideToolTip: true
    }));
  }
  return /*#__PURE__*/jsxs(EntityContainer, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [thumbnailProps && /*#__PURE__*/jsx(EntityThumbnail, {
      url: thumbnailProps.url
    }), /*#__PURE__*/jsx(ImgContainer, {
      children: entityImg
    }), /*#__PURE__*/jsxs(EntityDetails, {
      children: [/*#__PURE__*/jsxs(EntityBody, {
        children: [(subject || predicate) && /*#__PURE__*/jsxs(EntityTitleContainer, {
          children: [subject && /*#__PURE__*/jsx(Subject, {
            children: subject
          }), "\xA0", predicate && /*#__PURE__*/jsx("span", {
            children: predicate
          })]
        }), children, !_isEmpty(timestampProps) && /*#__PURE__*/jsx(StyledTimestamp, _objectSpread({}, timestampProps))]
      }), /*#__PURE__*/jsx(ActionBtnGroup, {
        primaryActions: primaryActions,
        secondaryActions: secondaryActions
      })]
    })]
  }));
});
Entity.displayName = "Entity";

export { Entity };
